import { useState, useEffect } from "react";
import { getAllPackages } from "../api/adminPackageClient";

export const usePackageAccess = () => {
    const [hasPackageAccess, setHasPackageAccess] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        checkAccess();
    }, []);

    const checkAccess = async () => {
        try {
            setIsLoading(true);
            const packages = await getAllPackages();
            // User has access if they can see any packages (admin, owner, or editor)
            setHasPackageAccess(packages.length > 0);
        } catch (error) {
            setHasPackageAccess(false);
        } finally {
            setIsLoading(false);
        }
    };

    return {
        hasPackageAccess,
        isLoading
    };
};
